
import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery, useMutation } from "react-query";


interface UpdateAnnulmentQueryViewStatusRequest {
  id: number;
  viewStatus: boolean;
}

async function updateAnnulmentQueryViewStatus(request: UpdateAnnulmentQueryViewStatusRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/Merchant/UpdateAnnulmentQueryViewStatus", request)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateAnnulmentQueryViewStatus() {
  return useMutation<any, Error, UpdateAnnulmentQueryViewStatusRequest>(
    (data) => updateAnnulmentQueryViewStatus(data)
  );
}
